export default function Logo({ size = "md", className = "" }) {
  const sizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-3xl",
    xl: "text-5xl",
  };
  return (
    <div className={`flex items-center gap-2 font-display ${sizes[size]} tracking-tight ${className}`} data-testid="brand-logo">
      <span className="font-light">dataeko</span>
      <span className="text-blue-500 font-semibold">.ai</span>
      <span className="ml-1 inline-block w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
    </div>
  );
}
